module.exports = __webpack_public_path__ + "static/media/goBack.1d7dfb28.svg";